export default "__VITE_ASSET__D5yxc0Xa__"